import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

export function BoardList() {
    const [board, setBoard] = useState([]);
    const [people, setPeople] = useState([]);
    const { authToken } = useAuth();

    useEffect(() => {
        const loadData = async () => {
            try {
                const token = localStorage.getItem("auth_token") || authToken;
                const headers = token ? { Authorization: `Bearer ${token}` } : {};
                
                const [boardRes, peopleRes] = await Promise.all([
                    axios.get("/api/board", { headers }),
                    axios.get("/api/directory", { headers }),
                ]);

                setBoard(boardRes.data);
                setPeople(peopleRes.data);
            } catch (err) {
                console.error("Error loading board or directory:", err);
            }
        };

        loadData();
    }, [authToken]);

    const personMap = {};
    people.forEach((p) => {
        personMap[p._id] = p;
    });

    return (
        <div className="container py-4">
            <div className="mx-auto" style={{ maxWidth: "750px" }}>
                {board.length === 0 ? (
                    <p className="text-muted">No board roles found.</p>
                ) : (
                    board.map((board_role) => {
                        const groupedByRole = {};

                        (board_role.members || []).forEach((member) => {
                            const person = personMap[member.userId];
                            const name = person
                                ? `${person.first_name} ${person.surname}${person.known_as ? ` (${person.known_as})` : ""}`
                                : "Unknown Member";

                            const role = member.role?.trim() || "Member";

                            if (!groupedByRole[role]) {
                                groupedByRole[role] = [];
                            }

                            groupedByRole[role].push({ name, userId: member.userId });
                        });

                        return (
                            <div key={board_role._id} className="mb-4">
                                <h5 className="border-bottom pb-1 text-center">{board_role.name}</h5>

                                {Object.keys(groupedByRole).length === 0 ? (
                                    <p className="text-muted">No members assigned.</p>
                                ) : (
                                    Object.entries(groupedByRole)
                                        .sort(([a], [b]) => a.localeCompare(b))
                                        .map(([role, members], idx) => {
                                            return (
                                                <div key={idx} className="mb-2">
                                                    <ul className="list-unstyled mb-0 ps-3">
                                                        {members
                                                            .sort((a, b) => a.name.localeCompare(b.name))
                                                            .map((member) => {
                                                                const person = personMap[member.userId];
                                                                return (
                                                                    <li key={member.userId} className="mb-2">
                                                                        <div className="fw-bold">{member.name}</div>

                                                                        {person && (
                                                                            <ul className="list-unstyled ps-3 mt-1 small text-muted">
                                                                                {person.email_address && (
                                                                                    <li>
                                                                                        <strong>Email:</strong>{" "}
                                                                                        <a href={`mailto:${person.email_address}`}>
                                                                                            {person.email_address}
                                                                                        </a>
                                                                                    </li>
                                                                                )}
                                                                                {person.cell_number && (
                                                                                    <li>
                                                                                        <strong>Cell:</strong> {person.cell_number}{" "}
                                                                                        {person.preferred_number === "cell" && (
                                                                                            <span className="text-body-secondary">(Preferred)</span>
                                                                                        )}
                                                                                    </li>
                                                                                )}
                                                                                {person.home_number && (
                                                                                    <li>
                                                                                        <strong>Home:</strong> {person.home_number}{" "}
                                                                                        {person.preferred_number === "home" && (
                                                                                            <span className="text-body-secondary">(Preferred)</span>
                                                                                        )}
                                                                                    </li>
                                                                                )}
                                                                                {person.physical_address && (
                                                                                    <li>
                                                                                        <strong>Address:</strong> {person.physical_address}
                                                                                    </li>
                                                                                )}
                                                                            </ul>
                                                                        )}
                                                                    </li>
                                                                );
                                                            })}
                                                    </ul>
                                                </div>
                                            );
                                        })
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}
